module.exports = __webpack_public_path__ + "static/img/icon0.f2338aee.svg";